import { forgetReferral } from './referral';
import { forgetReturnTo, returnTo } from './returnTo';
import { leaveWithSession } from './handoff';

/*
 * Leave signup for where it was started from (else the console) with nothing
 * left behind: a referral only ever applies to a NEW organization, and the
 * return address is spent once used.
 */
export function leaveSignup(after = 0): () => void {
    forgetReferral();
    const target = returnTo(import.meta.env.VITE_DEFAULT_REDIRECT);
    forgetReturnTo();
    const go = () => void leaveWithSession({ target, endSignup: true });
    if (after <= 0) {
        go();
        return () => {};
    }
    const t = window.setTimeout(go, after);
    return () => window.clearTimeout(t);
}
